;
/**
 *  CustomToolbox
 *
 *  Hier k�nnen spezielle MapToolboxen definiert werden.
 *
 */

HafasWebapp.prototype.Controller.CustomToolbox = {
  index: function() {

    /*
     * Folgendes ist n�tig um einen neuen Toolbox Typen zu definieren:
     */


    /*
    Hafas.Modules.Maps.addToolboxType(
            "[Name/Id der Toolbox]",
            {
              Optionen:

              Hier werden die Unterschiede zur Standard MapToolbox definiert. Funktionen und Werte definieren die Funktionen und Werte der Standard Toolbox �ber. Die folgenden Werte k�nnen angegeben werden (alle optional):

              template: <String> Welchen Template soll verwendet werden
              file: <String> In welcher Datei liegt das Template
              prio: <int> In welcher Reihenfolde soll die Infobox gecheckt werden (siehe check Funktion)
              show: <Function> Die Show Funktion wird aufgerufen wenn die Toolbox angezeigt wird. Von hier aus sollte die Funktion create aufgerufen werden.
              onShow: <Function> Wird nach dem Anzeigen aufgerufen
              createData: <Function> Bereitet die Daten zum rendern in den Templates auf function(rawData) { ... return data; }
              getCoord: <Function> Gibt die Koordinaten aus dem Daten zur�ck
              onClose: <Function> Wird nach dem schlie�en der Toolbox aufgerufen
            },
            <Function> Check Funktion. Diese Funktion �berpr�ft an Hand der �bergebenen Daten ob die Toolbox f�r diese Daten verwendet werden soll.
            (Tollbox mit h�chster prio wird verwendet) Wird keine Toolbox ausgew�hlt wird die Standadtoolbox genommen.
            Beispiel:
            function(data) {
                if(data.type == 2)
                  return true;
            }
      );
      */

  }
};


